module.exports = __webpack_public_path__ + "img/Vector.2a6d0fca.svg";